// enabled: false, does not work if there are some charts enabled in the same page
// so we need to set the line to transparent
export const DisabledCrosshair = {
  line: {
    color: "#00000000",
  },
  zoom: {
    enabled: false,
  },
};
